import LanguageToggle from '../src/LanguageToggle';
export default LanguageToggle;
